exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700);", ""]);

// module
exports.push([module.id, "*{box-sizing:border-box}*,body,html{margin:0;padding:0}body,html{height:100%}#app{padding-top:52px}body{background:#fbfbfb;font-family:Open Sans,sans-serif}section{margin:30px 20%}h2{margin:55px 0 20px}h3{margin:30px 0 10px}p{font-size:18px;margin:30px 0 15px}pre{padding:10px;font-size:1.4em;margin:10px 0;background:#fff;border-radius:4px;margin-bottom:40px;border:1px solid #e6e6e6;border-bottom:3px solid #ababab}code{background:#fff!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!./styles/index.css
// module id = 214
// module chunks = 0